<div class="verification-page">
    <div class="container d-flex">
        <div class="info-content hide-mobile">
            <div class="info">
                <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <h2 class="my-5">
                    {{user?.status === 'provisioning' ? (_translateService.Keys.VERIFICATION_IS_THIS_YOU | translate) : (_translateService.Keys.VERIFICATION_AFP_ACCOUNT_INFO | translate)}}
                </h2>
                <p *ngIf="user?.status === 'provisioning'">{{ _translateService.Keys.VERIFICATION_IF_SO_CONTINUE | translate }}</p>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content">
            <div class="form">
                <form (ngSubmit)="onSubmit()" #form="ngForm">
                    <div class="form-group">
                        <input class="form-input" name="userName" type="text" id="welcome-user-name"
                            [ngModel]="user && user.verificationInfo.userName"
                            [disabled]="true"
                            placeholder="{{ _translateService.Keys.VERIFICATION_USER_NAME | translate }}" required/>
                        <label for="welcome-user-name" class="form_label">{{ _translateService.Keys.VERIFICATION_USER_NAME | translate }}</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="phone" type="tel" id="welcome-phone"
                            [ngModel]="user && user.verificationInfo.userPhone"
                            placeholder="{{ _translateService.Keys.VERIFICATION_MOBILE_PHONE | translate }}"
                            [disabled]="true"
                            required/>
                        <label for="welcome-phone" class="form_label">{{ _translateService.Keys.VERIFICATION_MOBILE_PHONE | translate }}</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="insuredName" type="text" id="ver-insured-name"
                            [ngModel]="user && user.verificationInfo.insuredName" placeholder="{{ _translateService.Keys.VERIFICATION_INSURED_NAME | translate }}"
                            [disabled]="true" required/>
                        <label for="ver-insured-name" class="form_label">{{ _translateService.Keys.VERIFICATION_INSURED_NAME | translate }}</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="amazonScacCode" type="text" id="ver-amazon-scac-code"
                            [ngModel]="user && user.verificationInfo.amazonScacCode" placeholder="{{ _translateService.Keys.VERIFICATION_AMAZON_SCAC_CODE | translate }}"
                            [disabled]="true" required/>
                        <label for="ver-amazon-scac-code" class="form_label">{{ _translateService.Keys.VERIFICATION_AMAZON_SCAC_CODE | translate }}</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="amazonDotNumber" type="text" id="ver-amazon-dot-number"
                            [ngModel]="user && user.verificationInfo.amazonDotNumber" [disabled]="true"
                            placeholder="{{ _translateService.Keys.VERIFICATION_DOT_NUMBER | translate }}" required/>
                        <label for="ver-amazon-dot-number" class="form_label">{{ _translateService.Keys.VERIFICATION_DOT_NUMBER | translate }}</label>
                    </div>
                    <p class="text-center">
                        <a [href]="'mailto:' + supportEmail + '?subject=' + (user?.verificationInfo?.insuredName || '')">
                            {{ _translateService.Keys.VERIFICATION_REPORT | translate }}
                        </a>
                        {{ _translateService.Keys.VERIFICATION_INCORRECT_INFO | translate }}
                    </p>
                </form>
            </div>
            <div class="actions pt-3">
                <button (click)="gotoHome()" class="primary-button">
                   {{ (_translateService.Keys.COMMON_BACK | translate)}}
                </button>
            </div>
        </div>
    </div>
</div>
